<template>
  <div v-loading="loading">
    <div v-show="data.title&&data.content" class="warp">
      <div class="div-layout pd0">
        <div class="articleSource">
          <div class="title">
            {{ data.title }}
          </div>
        </div>
        <el-main>
          <div id="detailDanye" class="content" />
        </el-main>
      </div>
    </div>
    <global-empty
      v-show="!data.title||!data.content"
      :label="`暂无数据~`"
      link-it="3"
    />
  </div>
</template>
<script>
import getContent from '@/api/content';
export default {
  name: 'Danye',
  data: () => {
    return {
      loading: false,
      data: {
        id: '',
        title: '',
        content: ''
      }
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.data.id = route.params.id;
        this.getDetail();
      },
      immediate: true
    }
  },
  methods: {
    // 获取单页的详情内容
    getDetail() {
      this.loading = true;
      // 获取详情
      const option = {
        identification: this.data.id
      };
      getContent['getEduSinglePagesDetail'](option)
        .then(res => {
          if (res.data === null || res.data === '' || res.data === 'undefind' || res.data.length <= 0) {
            this.data.content = '';
            this.data.title = '';
            this.$router.push('/404');
          } else if (res.data.length > 0) {
            this.data = res.data[0];
            document.getElementById('detailDanye').innerHTML = this.data.content;
            this.data.title = this.data.title;
          }
          this.loading = false;
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.warp {
  margin: 20px;
  .content{line-height: 30px; }
  .articleSource{
    padding: 20px;
    border-bottom: 1px solid #f4f4f4;
    }
    .title{
      font-size: 18px;
      font-weight: bold;
      }
}
</style>
